const KEY = 'crm.jwt';

export const tokenStorage = {
  get: (): string | null => localStorage.getItem(KEY),
  set: (t: string) => localStorage.setItem(KEY, t),
  clear: () => localStorage.removeItem(KEY),
};

export interface JwtPayload { sub: string; role: 'super_admin' | 'company_admin' | 'company_user'; companyUid: string | null; exp: number; }

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const [, payload] = token.split('.');
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch { return null; }
}
